const BASE = process.env.REACT_APP_API_URL || "/api";

function getToken() {
  return localStorage.getItem("token");
}

async function request(method, path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });

  if (res.status === 401) {
    localStorage.removeItem("token");
    window.location.reload();
  }

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Error ${res.status}`);
  return data;
}

export const api = {
  // Auth
  login:          (email, password) => request("POST", "/auth/login", { email, password }),
  me:             ()                => request("GET",  "/auth/me"),
  changePassword: (body)            => request("POST", "/auth/change-password", body),

  // UF
  ufHoy:          ()                => request("GET",  "/uf/hoy"),
  ufHistorico:    ()                => request("GET",  "/uf/historico"),

  // Dashboard
  dashboard:      ()                => request("GET",  "/dashboard"),

  // Clientes
  clientes:       ()                => request("GET",  "/clientes"),
  clienteCreate:  (data)            => request("POST", "/clientes", data),
  clienteUpdate:  (id, data)        => request("PUT",  `/clientes/${id}`, data),
  clienteDelete:  (id)              => request("DELETE",`/clientes/${id}`),

  // Facturas
  facturas:       (params = {})     => request("GET",  "/facturas?" + new URLSearchParams(params)),
  emitirFacturas: (body)            => request("POST", "/facturas/emitir", body),
  verificarDTE:   (id)              => request("POST", `/facturas/${id}/verificar`),
  enviarEmail:    (id, emails)      => request("POST", `/facturas/${id}/email`, { emails }),

  // Config
  getConfig:      ()                => request("GET",  "/config"),
  saveConfig:     (data)            => request("PUT",  "/config", data),

  // Pagos
  pagos:           (factura_id)      => request("GET",  "/pagos?factura_id=" + factura_id),
  registrarPago:   (data)            => request("POST", "/pagos", data),
  eliminarPago:    (id)              => request("DELETE", `/pagos/${id}`),
  registrarAbono:  (data)            => request("POST", "/pagos/abono", data),
  eliminarAbono:   (id)              => request("DELETE", `/pagos/abono/${id}`),

  // Reportes
  estadoCuenta:    (clienteId)       => request("GET", `/reportes/cliente/${clienteId}`),
  reporteExcelMensual: (mes, anio) => {
    const token = localStorage.getItem("token");
    return fetch(`/api/reportes/excel-mensual?mes=${mes}&anio=${anio}`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(r => r.blob());
  },

  // PDF de una factura (blob, requiere Authorization)
  facturaPdf: async (id) => {
    const res = await fetch(`/api/facturas/${id}/pdf`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    if (res.status === 401) { localStorage.removeItem("token"); window.location.reload(); }
    if (!res.ok) {
      const d = await res.json().catch(() => ({}));
      throw new Error(d.error || `Error ${res.status}`);
    }
    return res.blob();
  },

  // Estado del sistema de respaldo
  backupEstado:    ()                => request("GET",  "/backup/status"),

  // SII
  contribuyente: (rut) => request("GET", `/sii/contribuyente/${rut}`),

  // Logs
  logs:            ()                => request("GET",  "/logs"),
  logsFacturas:    ()                => request("GET",  "/logs/facturas"),

  // Usuarios
  usuarios:        ()                => request("GET",  "/users"),
  usuarioCreate:   (data)            => request("POST", "/users", data),
  usuarioUpdate:   (id, data)        => request("PUT",  `/users/${id}`, data),
  usuarioDelete:   (id)              => request("DELETE", `/users/${id}`),
};

